import {
    SET_BULK_FLEET_HISTORY_TIMELINE,
    SET_BULK_ORDER_ALERT,
    SET_BULK_ORDER_DESCRIPTION_DROPDOWN,
    SET_BULK_ORDER_EXCEL_DATA,
    SET_BULK_ORDER_FLEET_ASSET,
    SET_BULK_ORDER_FLEET_HEADER,
    SET_BULK_ORDER_FLEET_PURCHASE_DETAIL,
    SET_BULK_ORDER_HEADER,
    SET_BULK_ORDER_PURCHASE_ORDER,
    SET_BULK_ORDER_VENDOR_DETAILS,
    SET_CANCEL_FLEET_ITEM,
    SET_CREATE_BULK_PO_DETAILS,
    SET_SAVE_BULK_FLEET_PURCHASE_DETAIL,
    SET_SAVE_VENDOR_DETAILS,
    SET_TASK_ASSIGNED_TO,
    SET_TASK_COMMENT,
    SET_TASK_HEADER_DETAILS,
    SET_TASK_ITEM_DETAILS,
    SET_SAVE_BULK_FLEET_PURCHASE_ORDER,
    SET_BULK_ORDER_FLEET_BARCODE,
    SET_CANCEL_BULK_ORDER
} from "./PurchaseBulkOrderType";

const reducers = (state = [], action: any) => {
    switch (action.type) {
        case SET_BULK_ORDER_HEADER:
            return {
                ...state,
                bulkOrderHeaderDetails: action.orderDetails
            }
        case SET_BULK_ORDER_FLEET_HEADER:
            return {
                ...state,
                bulkOrderFleetDetails: action.fleetDetails
            }
        case SET_BULK_ORDER_FLEET_PURCHASE_DETAIL:
            return {
                ...state,
                bulkOrderFleetPurchaseDetails: action.purchaseDetails
            }
        case SET_SAVE_BULK_FLEET_PURCHASE_DETAIL:
            return {
                ...state,
                isBulkFleetPurchaseDetailSaved: action.isBulkFleetPurchaseDetailSaved
            }
        case SET_BULK_ORDER_FLEET_ASSET:
            return {
                ...state,
                bulkOrderAssetDetail: action.assetDetails
            }
        case SET_BULK_ORDER_EXCEL_DATA:
            return {
                ...state,
                bulkOrderExcelData: action.excelData
            }
        case SET_TASK_HEADER_DETAILS:
            return {
                ...state,
                taskHeaderDetails: action.headerDetails
            }
        case SET_TASK_ITEM_DETAILS:
            return {
                ...state,
                taskItemDetails: action.itemDetails
            }
        case SET_TASK_ASSIGNED_TO:
            return {
                ...state,
                taskAssignedTo: action.assignedTo
            }
        case SET_TASK_COMMENT:
            return {
                ...state,
                taskComment: action.comment
            }
        case SET_CANCEL_FLEET_ITEM:
            return {
                ...state,
                cancelFleetItem: action.res
            }
        case SET_BULK_ORDER_DESCRIPTION_DROPDOWN:
            return {
                ...state,
                bulkOrderDescriptionDropdownList: action.dropdownList
            }
        case SET_BULK_ORDER_VENDOR_DETAILS:
            return {
                ...state,
                bulkOrderVendorDetails: action.bulkOrderVendorDetails
            }
        case SET_BULK_ORDER_PURCHASE_ORDER:
            return {
                ...state,
                bulkOrderPurchaseOrder: action.bulkOrderPurchaseOrder
            }
        case SET_SAVE_VENDOR_DETAILS:
            return {
                ...state,
                isVendorDetailsSaved: action.isVendorDetailsSaved
            }
        case SET_BULK_ORDER_ALERT:
            return {
                ...state,
                bulkOrderAlert: action.bulkOrderAlert
            }
        case SET_CREATE_BULK_PO_DETAILS:
            return {
                ...state,
                createdBulkPODetails: action.createdBulkPODetails
            }
        case SET_BULK_FLEET_HISTORY_TIMELINE:
            return {
                ...state,
                bulkFleetHistoryTimeLine: action.bulkFleetHistoryTimeLine
            }   
        case SET_SAVE_BULK_FLEET_PURCHASE_ORDER:
            return {
                ...state,
                isBulkFleetPurchaseOrderSaved: action.isBulkFleetPurchaseOrderSaved
            } 
        case SET_BULK_ORDER_FLEET_BARCODE:
            return {
                ...state,
                bulkOrderBarcodeDetail: action.response
            } 
        case SET_CANCEL_BULK_ORDER:
            return {
                ...state,
                cancelBulkOrder: action.res
            }
        default:
            return state;
    }
};

export {
    reducers
};